module.exports = __webpack_public_path__ + "static/bg3-e6a2323cf37cd406f072b90539591ee7.png";